import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { availableOnlineType } from "app/location/available-online-type.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-available-online-select",
  templateUrl: "./available-online-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class AvailableOnlineSelectComponent implements OnInit {
  public readonly availableOnlineTypeChange = output();
  @Input() public availableOnline = availableOnlineType.both;
  public readonly disabled = input(false);

  public subscription = new Subscription();
  public availableOnlineTypeList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildTypeList();
  }

  public onTypeChange(event) {
    this.availableOnlineTypeChange.emit(event.value);
  }

  private buildTypeList() {
    Object.keys(availableOnlineType).map((key) => {
      this.availableOnlineTypeList.push({
        label: availableOnlineType[key],
        value: key,
      });
    });
  }
}
